import React from "react";
import styled from "@emotion/styled";
import { Typography, Divider, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { toCurrency } from "@helpers";
import { BookingActionMenu } from "./InvestmentTable/InvestmentDetailModal/BookingActionMenu";
import { isBookingEditable } from "./InvestmentTable/InvestmentDetailModal/EditBookingModal";
import { TableBookingData } from "./BookingsSingleInvestmentTable";

const RowContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const DividerStyled = styled(Divider)`
  margin: ${({ theme }) => theme.spacing(1)} 0;
  border-color: ${({ theme }) => theme.palette.border.secondary};
`;

const CommentTextStyled = styled(Typography)`
  word-break: break-word;
`;

interface Props extends Omit<TableBookingData, "investmentType"> {
  onEdit: (bookingId: number) => void;
  onDelete: (bookingId: number) => void;
}

export const BookingsDetailsMobileView = ({
  id,
  expenses,
  comment,
  currency,
  bookingType,
  onEdit,
  onDelete,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box
      p={3}
      sx={{
        backgroundColor: "background.neutral",
        borderRadius: "8px",
      }}
    >
      <RowContainer>
        <Box>
          <Typography variant="body1">
            {t("investment.protocolTable.expenses")}
          </Typography>
          <Typography variant="body3">
            {toCurrency(expenses, currency)}
          </Typography>
        </Box>
        <Box>
          <BookingActionMenu
            showEdit={isBookingEditable(bookingType)}
            onEdit={() => onEdit(id)}
            onDelete={() => onDelete(id)}
          />
        </Box>
      </RowContainer>
      <DividerStyled />
      {comment ? (
        <div>
          <Typography variant="body1">
            {t("investment.protocolTable.comment")}
          </Typography>
          <CommentTextStyled variant="body3">{comment}</CommentTextStyled>
        </div>
      ) : null}
    </Box>
  );
};
